import React from 'react';
import List from 'components/List';
import { BooleanField, BooleanInput, Datagrid } from 'react-admin';
import LinkField from 'components/LinkField';
import IdInput from 'components/Filter/IdInput';
import MarketInput from 'components/MarketInput';
import LocationTypeInput from 'components/LocationTypeInput';
import { gql } from '@apollo/client';

const MarketLocationTypeRateSettingsListFilters = [
  <IdInput />,
  <MarketInput alwaysOn />,
  <LocationTypeInput label="Location Type" source="location_type_id" alwaysOn resettable />,
  <BooleanInput alwaysOn source="active" />,
];

const MarketLocationTypeRateSettingsList = () => (
  <List filters={MarketLocationTypeRateSettingsListFilters} exporter={false}>
    <Datagrid bulkActionButtons={false}>
      <LinkField label="ID" source="id" />
      <LinkField label="Market" source="market.display_name" sortBy="market_name" />
      <LinkField label="Location Type" source="location_type.label" sortBy="location_type_name" />
      <BooleanField source="active" />
      <BooleanField
        label="Track Unpaid Breaks"
        source="settings.track_unpaid_breaks"
        sortable={false}
      />
    </Datagrid>
  </List>
);
export default MarketLocationTypeRateSettingsList;

MarketLocationTypeRateSettingsList.query = gql`
  query marketLocationTypeRateSettings($input: MarketLocationTypeRateSettingQueryInput) {
    _marketLocationTypeRateSettingsMeta(input: $input) {
      count
    }
    marketLocationTypeRateSettings(input: $input) {
      id
      active
      location_type {
        id
        label
      }
      market {
        id
        display_name
      }
      settings
      updated_at
    }
  }
`;
